import GoKuSubmitFuel from './GoKuSubmitFuel'

export default GoKuSubmitFuel
